import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=058f983b&scoped=true"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"
import style0 from "./settings.vue?vue&type=style&index=0&id=058f983b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f983b",
  null
  
)

export default component.exports